














































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import StepCorrectCheckList from "@/components/contract-moving/step/stepCorrectCheckList.vue";
import StepCheckList from "@/components/contract-moving/step/stepCheckList.vue";
import MovingSignature from "@/components/contract-moving/movingSignature.vue";
import { namespace } from "vuex-class";
import ContractMoveOut, { CONTRACT_STEP } from "@/model/contractMoveOut";
import qNotify from "@/common/qNotify";
import VueScrollTo from "vue-scrollto";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
const moveOutStore = namespace("MoveOut");

@Component({
  name: "StepReSignature",
  components: {
    StepCorrectCheckList, 
    StepCheckList,
    MovingSignature,
  },
})
export default class StepReSignature extends Vue {
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;

  public moveOutObject: ContractMoveOut = new ContractMoveOut();
  public errors = {};

  mounted() {
    this.moveOutObject = new ContractMoveOut(_.cloneDeep(this.getMoveOut));
    this.moveOutObject.re_sign = true;
  }
  public async returnCheckList() {
    const result = await this.moveOutObject.goBack({
      step: CONTRACT_STEP.STEP_CORRECT_CHECK_LIST,
    });
    if (result.meta.status === 200) {
      this.$router.replace({ query: { step: uuidv4() } });
      VueScrollTo.scrollTo({ force: true });
    } else {
      qNotify.error({
        text: result.meta.message,
      });
      this.errors = result.meta.errors;
    }
  }
}
